import { Button as MUIButton } from '@material-tailwind/react'
import { color } from '@material-tailwind/react/types/components/button'
import React, { ChangeEvent, useContext, useState } from 'react'
import { FaCloud, FaPhone, FaEnvelope, FaSkype, FaGithub } from 'react-icons/fa'
import { ThemeContext } from '../../../../App'
import Input from '../input'
import TextArea from '../textarea'
import Tooltip from '../tooltip'
import data from '../../../../data.json'

const ContactMe = () => {
  const theme = useContext(ThemeContext)
  const [email, setEmail] = useState({
    name: '',
    subject: '',
    message: '',
  })

  const inputChangeHandler = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target
    setEmail({ ...email, [name]: value })
  }
  console.log(email)

  return (
    <div className="h-[560px] w-full max-w-[380px] text-ellipsis rounded-[10px] bg-[linear-gradient(105deg,rgba(0,0,0,0.53),rgba(0,0,0,0.6),rgba(0,0,0,0.4),rgba(0,0,0,0.6),rgba(0,0,0,0.53))] px-5 py-8 text-center shadow-[5px_5px_15px_rgba(0,0,0,0.53)]">
      <h2 className="mb-3 text-2xl font-bold">Contact Me</h2>
      <Input placeholder="Your Name" value={email.name} name="name" onChange={inputChangeHandler} />
      <Input
        placeholder="Subject"
        value={email.subject}
        name="subject"
        onChange={inputChangeHandler}
      />
      <TextArea
        placeholder="Your message here..."
        value={email.message}
        name="message"
        onChange={inputChangeHandler}
      ></TextArea>
      <p className="mt-5 mb-4 text-[#ffffff97]">Currently open to REMOTE only...</p>
      <a
        href={`mailto:gurodahony@gmail.com?subject=${email.subject}&body=${email.message}%0D%0A%0D%0A${email.name}`}
      >
        <MUIButton
          color={theme.buttonColor as color}
          className={`py-2 text-[14px] transition-all duration-1000`}
        >
          SEND MESSAGE
        </MUIButton>
      </a>
      <div className="mt-5 flex w-full">
        {/* <div className="w-full">
          <Tooltip
            id="tooltip-linkedin"
            title="https://www.linkedin.com/"
            href="https://www.linkedin.com/"
            bgColor="blue"
          >
            <FaLinkedin className="m-auto h-6 w-6" />
          </Tooltip>
        </div> */}
        {/* <div className="w-full">
          <Tooltip
            id="tooltip-cv"
            title="Resume"
            bgColor="teal"
          >
            <FaCloud className="m-auto h-6 w-6" />
          </Tooltip>
        </div> */}
        {/* <div className="w-full">
          <Tooltip
            id="tooltip-phone"
            title="+381 616143737"
            href="tel:+381 616143737"
            bgColor="green"
          >
            <FaPhone className="m-auto h-6 w-6" />
          </Tooltip>
        </div> */}
        <div className="w-full">
          <Tooltip
            id="tooltip-mail"
            title="gurodahony@gmail.com"
            href="mailto:gurodahony@gmail.com"
            bgColor="red"
          >
            <FaEnvelope className="m-auto h-6 w-6" />
          </Tooltip>
        </div>
        <div className="w-full">
          <Tooltip
            id="tooltip-skype"
            title="live:.cid.cbca59438f0dca4a"
            href="skype:live:.cid.cbca59438f0dca4a?chat"
            bgColor="light-blue"
          >
            <FaSkype className="m-auto h-6 w-6" />
          </Tooltip>
        </div>
        <div className="w-full">
          <Tooltip
            id="tooltip-github"
            title="https://github.com/super0111"
            href="https://github.com/super0111"
            bgColor="gray"
          >
            <FaGithub className="m-auto h-6 w-6" />
          </Tooltip>
        </div>
      </div>
    </div>
  )
}

export default ContactMe
